import { api as $axios } from '@/helpers/interceptors'
import { GET_SMS, SEND_SMS, UPLOAD_SMS } from '@/constants/path'
import snakeCaseKeys from 'snakecase-keys'
import { meta } from '@/config/pagination'

const setUnLoading = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoading',
    value: status,
  })
}

const setUnLoadingBtnSend = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoadingBtnSend',
    value: status,
  })
}
const state = () => ({
  data: [],
  isLoading: false,
  meta: meta,
  isLoadingBtnSend: false,
  isLoadingUploadFile: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getSms({ commit }, params) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(
        `${GET_SMS}`,
        'get',
        snakeCaseKeys({ params }),
      )
      commit('SET_STATE', {
        key: 'data',
        value: res?.data?.data,
      })
      commit('SET_STATE', {
        key: 'meta',
        value: res?.data?.meta,
      })
      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', { key: 'data', value: [] })
      setUnLoading(commit)
    }
  },
  async sendSms({ commit }) {
    setUnLoadingBtnSend(commit, true)
    try {
      await $axios(`${SEND_SMS}`, 'post')
      setUnLoadingBtnSend(commit)
    } catch (error) {
      setUnLoadingBtnSend(commit)
    }
  },

  async uploadFile({ commit }, data) {
    try {
      commit('SET_STATE', {
        key: 'isLoadingUploadFile',
        value: true,
      })
      await $axios(`${UPLOAD_SMS}`, 'post', data)
      commit('SET_STATE', {
        key: 'isLoadingUploadFile',
        value: false,
      })
    } catch (error) {
      commit('SET_STATE', {
        key: 'isLoadingUploadFile',
        value: false,
      })
    }
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
